export const SHIPMENTS_RESET_STATE = 'SHIPMENTS_RESET_STATE';
export const SHIPMENTS_CURRENT_ITEM = 'SHIPMENTS_CURRENT_ITEM';

export const SHIPMENTS_REQUEST_LOADING = 'SHIPMENTS_REQUEST_LOADING';
export const SHIPMENTS_REQUEST_SUCCESS = 'SHIPMENTS_REQUEST_SUCCESS';
export const SHIPMENTS_REQUEST_FAILED = 'SHIPMENTS_REQUEST_FAILED';

export const SHIPMENTS_CURRENT_ACTION = 'SHIPMENTS_CURRENT_ACTION';
export const SHIPMENTS_RESET_ACTION = 'SHIPMENTS_RESET_ACTION';